<template>
  <form
    v-if="!appState$$.isLogged"
    id="login-form"
    name="login-form"
    method="POST"
    class="autorization-body-form-clave"
    :action="refUrlClaveLogin"
  >
    <input
      type="hidden"
      name="urlok"
      :value="getUrlSend()"
    />
    <input
      type="hidden"
      name="urlko"
      :value="refKO"
    />
    <input
      type="hidden"
      name="noeidas"
      value="true"
    >
    <input
      type="hidden"
      name="procedureAlias"
      value="SirdeSubvenciones"
    >
    <Button
      type="submit"
      tabindex="0"
      class="bttn-AJ autorization-body-form-clave__button"
    >
      <img
        src="~@/assets/images/logo-clave.svg"
        alt="Acceso con Cl@ve"
      />
    </Button>
  </form>
</template>

<script setup>
// #region Vue
import {
  ref,
  inject,
} from 'vue';
// #endregion

// #region Components
import Button from 'primevue/button/sfc';
// #endregion

// #region Props, Emits
// ...
// #endregion

// #region Params, Ref, Reactives, Computed
const appState$$ = inject('appState$$');

const typePortal = ref(STTEDRA_TYPE_PORTAL);
const refUrlClaveLogin = ref(STTEDRA_CLAVE_URL_LOGIN);
const refOK = ref(STTEDRA_URL_OK);
const refOkTutor = ref(STTEDRA_URL_OK_TUTOR);
const refKO = ref(STTEDRA_URL_KO);
// #endregion

// #region Functions
function getUrlSend() {
  return typePortal.value === 'codigos' && appState$$.isTutorizeRegister ? refOkTutor.value : refOK.value;
}
// #endregion

// #region Effects, Hooks
// ...
// #endregion

// #region Provide, Expose
// ...
// #endregion
</script>

<style lang="scss" scoped>
@use '@/styles/vars' as *;
@use '@/styles/breakpoints' as *;

.autorization-body-form-clave{
  &__button:enabled:hover {
    background-color: $pv__color--white !important;
    outline-offset: 2px;
    outline: 2px solid $pv__color--green-alter;
  }

  &__button{
    width: auto !important;
    height: 50px !important;
    display: flex;
    justify-content: center;
    background-color: $pv__color--white;
    border:1px solid $pv__color--green-alter;
    padding: ($brand__boxspace--medium * 0.75) ($brand__boxspace--medium * 2);
    & img {
      height: 32px;
    }
  }
}
</style>
